import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

interface VoivodeshipState {
  value: string;
}

const initialState: VoivodeshipState = {
  value: "All",
};

export const voivodeshipSlice = createSlice({
  name: "voivodeship",
  initialState,
  reducers: {
    setVoivodeshipValue: (state, action: PayloadAction<string>) => {
      state.value = action.payload;
    },
  },
});

export const { setVoivodeshipValue } = voivodeshipSlice.actions;



// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectVoivodeship = (state: RootState) => state.voivodeship.value;

export default voivodeshipSlice.reducer;
